// ── Klaviyo wiring ─────────────────────────────────────────────
var KLAVIYO_COMPANY_ID = 'SBRTZS';        // Tend public API key
var KLAVIYO_LIST_ID    = 'X4XTbL';        // "Tend Well Waitlist" (single opt-in)
var CUSTOM_SOURCE      = 'Tend Well Waitlist Lander';
var REASON_PROPERTY    = 'Womens Interest Reason';
var KLAVIYO_REVISION   = '2024-10-15';

// ── Pre-order switch ───────────────────────────────────────────
// Flip to true when the product goes Active. The lander then surfaces
// "Pre-order now" CTAs pointing at the PDP; waitlist capture stays available
// underneath for anyone not ready to buy.
var PREORDER_LIVE = false;
var PRODUCT_URL = 'https://www.tendprenatal.com/products/womens-multi'
  + '?utm_source=waitlist-lander&utm_medium=referral&utm_campaign=womens-multi-launch';

// Fallback chips, used only if the section hands over nothing usable. The
// label is authored in the theme editor; the value is fixed in the section so
// rewording a chip never changes what Klaviyo stores.
var DEFAULT_REASONS = [
  { label: 'I had babies and never quite got back to myself', value: 'depleted' },
  { label: 'I’m past the baby years and thinking about my bones', value: 'next' },
  { label: 'I’m tired of the shelf of bottles and want one thing', value: 'simplify' }
];

// Shared across both forms: the same question asked twice, so one answer
// serves both. `email` is kept so the reason can be attached to that profile
// after the fact; `joined` makes both forms show the thank-you.
var state = { reason: '', email: '', joined: false };
var forms = [];

function readReasons(root) {
  var el = root && root.querySelector('[data-tw-reasons]');
  try {
    var raw = el && el.getAttribute('data-tw-reasons');
    if (raw) {
      var authored = JSON.parse(raw).filter(function (r) {
        return r && typeof r.label === 'string' && r.label.trim();
      });
      if (authored.length) return authored;
    }
  } catch (e) { /* fall through to the defaults */ }
  return DEFAULT_REASONS;
}

function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); }

function reasonProps(reason) {
  var props = {};
  props[REASON_PROPERTY] = reason;
  return props;
}

// The single submit path for every form on the page. A reason is only ever
// included when a ?reason= link already told us; otherwise it is asked after.
function subscribe(email, reason) {
  var attrs = { email: email };
  if (reason) attrs.properties = reasonProps(reason);
  return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: CUSTOM_SOURCE,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
      }
    })
  }).then(function (res) {
    if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
  });
}

// Writes the reason onto the profile that just signed up. Best effort by
// design: the email is already captured and on the list, so a failure here
// must never show the visitor an error or undo their signup.
function recordReason(email, reason) {
  return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
    body: JSON.stringify({
      data: { type: 'profile', attributes: { email: email, properties: reasonProps(reason) } }
    })
  }).catch(function () { /* best effort */ });
}

function TwForm(root, reasons) {
  this.root = root;
  this.reasons = reasons;
  this.body = root.querySelector('[data-tw-body]');
  this.emailInput = root.querySelector('[data-tw-email]');
  this.joinBtn = root.querySelector('[data-tw-join]');
  this.emailError = root.querySelector('[data-tw-email-error]');
  this.submitError = root.querySelector('[data-tw-submit-error]');
  this.successEl = root.querySelector('[data-tw-success]');
  this.askEl = root.querySelector('[data-tw-ask]');
  this.chipsEl = root.querySelector('[data-tw-chips]');
  this.thanksEl = root.querySelector('[data-tw-ask-thanks]');
  this.submitting = false;

  var self = this;

  this.reasons.forEach(function (r) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tw-chip';
    b.textContent = r.label;
    b.addEventListener('click', function () { self.pickReason(r.value); });
    self.chipsEl.appendChild(b);
  });

  this.joinBtn.addEventListener('click', function () { self.join(); });
  this.emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') self.join();
  });
  this.emailInput.addEventListener('input', function () { self.clearErrors(); });
}

TwForm.prototype.pickReason = function (value) {
  state.reason = state.reason === value ? '' : value;
  forms.forEach(function (f) { f.syncChips(); });
  if (state.reason && state.email) recordReason(state.email, state.reason);
};

TwForm.prototype.syncChips = function () {
  var reasons = this.reasons;
  Array.prototype.forEach.call(this.chipsEl.children, function (el, i) {
    el.classList.toggle('tw-on', reasons[i] && reasons[i].value === state.reason);
  });
  this.thanksEl.classList.toggle('tw-show', !!state.reason);
};

TwForm.prototype.clearErrors = function () {
  this.emailError.classList.remove('tw-show');
  this.submitError.classList.remove('tw-show');
  this.emailInput.classList.remove('tw-error');
};

// Swap the field for the thank-you. The reason is asked here — unless a
// ?reason= link already answered it, in which case there is nothing to ask.
TwForm.prototype.showSuccess = function () {
  this.body.classList.add('tw-gone');
  this.successEl.classList.add('tw-show');
  if (!state.reason) this.askEl.classList.add('tw-show');
};

TwForm.prototype.join = function () {
  if (state.joined || this.submitting) return;
  var email = this.emailInput.value;
  this.clearErrors();
  // The email is the only requirement: nothing gates this field.
  if (!validEmail(email)) {
    this.emailError.classList.add('tw-show');
    this.emailInput.classList.add('tw-error');
    return;
  }
  var self = this;
  this.submitting = true;
  this.joinBtn.disabled = true;
  subscribe(email.trim(), state.reason).then(function () {
    state.joined = true;
    state.email = email.trim();
    forms.forEach(function (f) { f.showSuccess(); });
  }).catch(function () {
    self.submitError.classList.add('tw-show');
  }).finally(function () {
    self.submitting = false;
    self.joinBtn.disabled = false;
  });
};

var reasons = readReasons(document);
Array.prototype.forEach.call(document.querySelectorAll('[data-tw-form]'), function (root) {
  forms.push(new TwForm(root, reasons));
});

// A known ?reason= arrives already validated and lowercased on <html>, set by
// the inline script in the section. It seeds the shared answer, so a signup
// from either form carries the property the link already told us and the
// thank-you does not ask again.
var urlReason = document.documentElement.getAttribute('data-tw-reason');
if (urlReason) {
  state.reason = urlReason;
  forms.forEach(function (f) { f.syncChips(); });
}

// "Not you?" in the ?reason= confirmation state: dropping the attribute puts
// the hero form back exactly as it renders without the parameter, and the
// reason from the link goes with it — so the thank-you will ask instead.
var undo = document.querySelector('[data-tw-undo]');
if (undo) {
  undo.addEventListener('click', function () {
    document.documentElement.removeAttribute('data-tw-reason');
    state.reason = '';
    forms.forEach(function (f) { f.syncChips(); });
    var field = document.querySelector('[data-tw-form][data-place="hero"] [data-tw-email]');
    if (field) field.focus();
  });
}

// ── Pre-order mode ─────────────────────────────────────────────
if (PREORDER_LIVE) {
  var eyebrow = document.querySelector('.tw-hero .tw-eyebrow');
  if (eyebrow) eyebrow.textContent = 'PRE-ORDER OPEN · SHIPS WEEK OF OCTOBER 13';
  var note = document.querySelector('.tw-hero-notes .tw-n1');
  if (note) note.textContent = 'Pre-orders ship the week of October 13.';
  // A pre-order CTA above each form; waitlist capture stays underneath.
  forms.forEach(function (f) {
    var cta = document.createElement('a');
    cta.href = PRODUCT_URL;
    cta.className = f.root.closest('.tw-closing') ? 'tw-btn-light' : 'tw-btn-dark';
    cta.textContent = 'Pre-order now';
    f.root.insertBefore(cta, f.root.firstChild);
  });
}